// src/hooks/programs/useUpdateProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useUpdateProgram = (onSuccessCallback) => {
    const queryClient = useQueryClient();

    const {
        mutate: updateProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateProgram(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
            queryClient.invalidateQueries({ queryKey: ["program"] });

            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update program");
        },
    });

    return {
        updateProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useUpdateProgram;
